/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';

import { useSelector } from 'react-redux';
import { SearchBarGlobalDatasource } from '@europrocurement/flexy-components';
import { getDataThunkType } from '@europrocurement/l2d-redux-utils';

import { useSearchBar } from '../providers/SearchBarProvider';
import { SearchBarRegistry } from '../providers/SearchBarRegistry';

const GenericSearchBar: React.FunctionComponent = function () {
    const { searchBarType } = useSearchBar();

    if (!searchBarType) {
        return null;
    }

    const config = SearchBarRegistry[searchBarType];

    if (!config) {
        console.warn(`SearchBar type ${searchBarType} not configured in registry`);
        return null;
    }

    // All hooks must be called before any early returns
    const { selector, serviceHook, getFetchFunction, placeholder } = config;
    const datasource = useSelector(selector).main;
    const service = serviceHook();
    const fetchFunction = getFetchFunction(service);

    return (
        <SearchBarGlobalDatasource
            datasource={datasource as { slicename: string; name: string; search: string }}
            fetchFunction={fetchFunction as getDataThunkType<Record<string, unknown>>}
            placeholder={placeholder}
        />
    );
};

export default GenericSearchBar;
